export default __webpack_public_path__ + "static/media/bgm.411fada7.wav";